/**
 * Resolve the `currentSubmissionDocument` value to persist when saving a
 * document.
 *
 * Only submission document types can be current. When the staff checkbox is
 * rendered, the form value is the user's explicit choice and must win — using
 * `??` (not `||`) so an explicit `false` (unchecking) is respected rather than
 * swallowed. When the checkbox is not rendered, the form value is absent and we
 * fall back to the existing value so it is preserved.
 */
export function resolveCurrentSubmissionDocument({
  isKnownSubmissionType,
  formValue,
  existingValue,
}: {
  isKnownSubmissionType: boolean;
  formValue: boolean | null | undefined;
  existingValue: boolean | null | undefined;
}): boolean {
  if (!isKnownSubmissionType) {
    return false;
  }
  return formValue ?? existingValue ?? false;
}
